
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.85 0H3.15A3.15 3.15 0 000 3.15v50.7A3.15 3.15 0 003.15 57h27.3V35H23v-8.67h7.41V20c0-7.37 4.49-11.38 11.06-11.38a62.15 62.15 0 016.68.38v7.69h-4.54c-3.57 0-4.26 1.69-4.26 4.18v5.5h8.55L46.79 35h-7.44v22h14.5A3.15 3.15 0 0057 53.85V3.15A3.15 3.15 0 0053.85 0z","fill":"#fff"}})])
          )
        }
      }
    